import { Box, Typography } from "@mui/material";
import GoogleButton from "react-google-button";
import { useCallback, useEffect, useState } from "react";
import { login } from "../features/authorization/authService";
import MicrosoftLoginButton from "../components/microsoftLoginButton/MicrosoftLoginButton";
import FacebookLoginButton from "../components/facebookLoginButton/FacebookLoginButton";

const LoginPage = () => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isHeightLessThan800, setIsHeightLessThan800] = useState(false);

  const checkWindowHeight = useCallback(() => {
    setIsHeightLessThan800(window.innerHeight < 800);
  }, []);

  useEffect(() => {
    checkWindowHeight();
    window.addEventListener("resize", checkWindowHeight);
    return () => window.removeEventListener("resize", checkWindowHeight);
  }, [checkWindowHeight]);

  const handleLoginAsync = async (
    provider: "Google" | "Microsoft" | "Facebook"
  ) => {
    setLoading(true);
    setError(null);

    try {
      await login(provider);
      setTimeout(() => setLoading(false), 1000);
    } catch (error) {
      setLoading(false);
      if (error instanceof Error) {
        setError(error.message);
      } else {
        setError(String(error));
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: isHeightLessThan800
          ? "calc(100vh - 64px)"
          : "calc(100vh - 192px)",
        padding: 2,
      }}
    >
      <Box
        sx={{
          width: "unset",
          maxWidth: 800,
          padding: { xs: 2, sm: 5, md: 5, lg: 5, xl: 5 },
          borderRadius: 3,
          boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          border: "1px solid #1976d2",
        }}
      >
        <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold" }}>
          Welcome to TeamRay
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          Sign in with your Google account to get started
        </Typography>

        <Box
          style={{
            pointerEvents: loading ? "none" : "auto",
            width: "100%",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: 5,
          }}
        >
          <GoogleButton
            type="dark"
            onClick={() => handleLoginAsync("Google")}
            style={{ opacity: loading ? 0.6 : 1, height: 50, width: "100%" }}
            disabled={loading}
          />

          <MicrosoftLoginButton
            onClick={() => handleLoginAsync("Microsoft")}
            isDisabled={loading}
          />

          <FacebookLoginButton
            onClick={() => handleLoginAsync("Facebook")}
            isDisabled={loading}
          />
        </Box>

        {error && (
          <Typography
            variant="body2"
            sx={{
              mt: 2,
              color: "error.main",
              backgroundColor: "#ffeeee",
              padding: 1,
              borderRadius: 1,
              width: "100%",
            }}
          >
            {error}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default LoginPage;
